var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "aside",
      class: { "is-active": _vm.isOpen },
      attrs: { id: "aside_" + _vm.name, inert: !_vm.isOpen },
    },
    [
      _c(
        "button",
        {
          staticClass: "close_aside",
          on: {
            click: function ($event) {
              return _vm.closeAside()
            },
          },
        },
        [_vm._v("\n        ×\n    ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "aside_wrapper" },
        [
          _c("div", { staticClass: "aside_head" }, [
            _vm.addToCartMessage
              ? _c("div", { staticClass: "cart_message cross-selling" }, [
                  _c(
                    "div",
                    { staticClass: "image" },
                    [
                      _c("lazy-img", {
                        attrs: {
                          "image-url":
                            "https://cdn.bio-kinder.de/frontend/images/icons/cart_success.svg",
                          "image-alt": "Erfolgreich hinzugefuegt",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "buttons" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-bkm-inverted close_aside",
                        attrs: { href: "#", "aria-label": "Schließen" },
                      },
                      [
                        _vm._v(
                          "\n                        Schließen\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-bkm",
                        attrs: {
                          href: _vm.$ceres.urls.checkout,
                          "aria-label": "Zur Kasse",
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$translate("Ceres::Template.basketCheckout")
                            ) +
                            "\n                        "
                        ),
                        _c("i", { staticClass: "ml-2 fa fa-arrow-right" }),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm._t("content", function () {
            return [
              _c(
                "div",
                { staticClass: "aside_content" },
                [
                  _vm.compiledComponentVisible
                    ? _c(_vm.compiledComponent, { tag: "component" })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isLoading ? _c("loading-animation") : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "aside_shadow",
        on: {
          click: function ($event) {
            return _vm.closeAside()
          },
        },
      }),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "info-message" }, [
      _c("span", { staticClass: "success-info" }, [
        _vm._v(
          "\n                        Erfolgreich zum Warenkorb hinzugefügt!\n                    "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }